import PaymentsAPI from 'dashboard/api/omni/payments';
import * as types from '../mutation-types';

const state = {
  orders: {
    data: [],
    summary: {},
    meta: {},
    uiFlags: { isFetching: false },
  },
  ledger: {
    data: [],
    summary: {},
    meta: {},
    uiFlags: { isFetching: false },
  },
  paymentAccounts: {
    data: [],
    uiFlags: { isFetching: false },
  },
};

const getters = {
  getOrders: ($state) => $state.orders.data,
  getOrdersSummary: ($state) => $state.orders.summary,
  getOrdersMeta: ($state) => $state.orders.meta,
  getOrdersUIFlags: ($state) => $state.orders.uiFlags,
  getLedgerEntries: ($state) => $state.ledger.data,
  getLedgerSummary: ($state) => $state.ledger.summary,
  getLedgerMeta: ($state) => $state.ledger.meta,
  getLedgerUIFlags: ($state) => $state.ledger.uiFlags,
  getPaymentAccounts: ($state) => $state.paymentAccounts.data,
  getPaymentAccountsUIFlags: ($state) => $state.paymentAccounts.uiFlags,
};

const actions = {
  async fetchOrders({ commit, rootGetters }, params = {}) {
    commit(types.default.SET_PAYMENTS_ORDERS_UI_FLAG, { isFetching: true });
    try {
      const accountId = rootGetters.getCurrentAccountId;
      const response = await PaymentsAPI.getOrders(accountId, params);
      commit(types.default.SET_PAYMENTS_ORDERS, response.data);
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      commit(types.default.SET_PAYMENTS_ORDERS_UI_FLAG, { isFetching: false });
    }
  },

  async fetchLedger({ commit, rootGetters }, params = {}) {
    commit(types.default.SET_PAYMENTS_LEDGER_UI_FLAG, { isFetching: true });
    try {
      const accountId = rootGetters.getCurrentAccountId;
      const [entriesRes, summaryRes] = await Promise.all([
        PaymentsAPI.getLedger(accountId, params),
        PaymentsAPI.getLedgerSummary(accountId, params),
      ]);
      commit(types.default.SET_PAYMENTS_LEDGER, {
        data: entriesRes.data.data,
        meta: entriesRes.data.meta,
        summary: summaryRes.data,
      });
    } catch (error) {
      console.error('Error fetching ledger:', error);
    } finally {
      commit(types.default.SET_PAYMENTS_LEDGER_UI_FLAG, { isFetching: false });
    }
  },

  async fetchPaymentAccounts({ commit, rootGetters }) {
    commit(types.default.SET_PAYMENTS_ACCOUNTS_UI_FLAG, { isFetching: true });
    try {
      const accountId = rootGetters.getCurrentAccountId;
      const response = await PaymentsAPI.getPaymentAccounts(accountId);
      commit(types.default.SET_PAYMENTS_ACCOUNTS, response.data);
    } catch (error) {
      console.error('Error fetching payment accounts:', error);
    } finally {
      commit(types.default.SET_PAYMENTS_ACCOUNTS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
};

const mutations = {
  [types.default.SET_PAYMENTS_ORDERS]($state, data) {
    $state.orders.data = data.data || [];
    $state.orders.summary = data.summary || {};
    $state.orders.meta = data.meta || {};
  },
  [types.default.SET_PAYMENTS_ORDERS_UI_FLAG]($state, flags) {
    $state.orders.uiFlags = { ...$state.orders.uiFlags, ...flags };
  },
  [types.default.SET_PAYMENTS_LEDGER]($state, data) {
    $state.ledger.data = data.data || [];
    $state.ledger.summary = data.summary || {};
    $state.ledger.meta = data.meta || {};
  },
  [types.default.SET_PAYMENTS_LEDGER_UI_FLAG]($state, flags) {
    $state.ledger.uiFlags = { ...$state.ledger.uiFlags, ...flags };
  },
  [types.default.SET_PAYMENTS_ACCOUNTS]($state, data) {
    $state.paymentAccounts.data = data;
  },
  [types.default.SET_PAYMENTS_ACCOUNTS_UI_FLAG]($state, flags) {
    $state.paymentAccounts.uiFlags = {
      ...$state.paymentAccounts.uiFlags,
      ...flags,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
